import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 8L6 4L10 8", stroke: "#666A80", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowUp;
